enum FeatureFlags {
  BannerImprovements = 'banner_improvements',
  ConfInteractiveMaps = 'is_interactive_maps_enabled',
  ConfLeadCapture = 'is_lead_capture_enabled',
  ConfLeadCaptureLicenseLimit = 'lead_capture_license_limit',
  ConfVideoLibraryEnabled = 'is_video_library_enabled',
  CustomSystemEmails = 'custom_system_emails',
  DomainWhitelisting = 'domain_whitelisting',
  EmbeddedWidgetsEnabled = 'embedded_widgets_enabled',
  ExpAddStaffMember = 'exp_add_staff_member',
  GroupRegistrationEnabled = 'group_registration_enabled',
  LoginRedesign = 'exp-login-redesign-enabled',
  SessionCompaniesSponsor = 'session_companies_sponsor',
}

export default FeatureFlags;
